<div class="mobi-ui-margin-t-xxl">
  <div class="view-enter-animation">
    <div class="mobi-ui-grid is-centered mobi-ui-margin-y-md">
      <div
        class="mobi-ui-col-1/1 xl:mobi-ui-col-3/4 !mt-0 mobi-ui-margin-b-xl text-center"
      >
        <h1 class="mobi-ui-font-h1 text-animation">
          {{ entity().title }}
        </h1>
        @if (entity().lead) {
          <mobi-text [data]="entity().lead" class="mobi-ui-font-100 text-lead" />
        }
      </div>
    </div>
  </div>

  @if (tabValues()) {
    <mobi-split-button-section
      [content]="buttonContent"
      [items]="tabLabels()"
      [activeItem]="activeItem()"
      [class.initial-corporate]="activeItem() === 1 && !hasSwitchedPage()"
      [transparent]="true"
      (onSplitButtonChange)="changePageContent($event)"
    >
      <ng-template
        #buttonContent
        let-currentItem="currentItem"
        class="mobi-ui-padding-b-xxxl"
      >
        @for (item of tabValues(); track item.viewId) {
          <div class="view-enter-animation mobi-ui-margin-t-md">
            @if (item.label === currentItem()) {
              <div>
                @if (item.title) {
                  <div class="mobi-ui-grid is-centered mobi-ui-margin-y-md">
                    <div class="mobi-ui-col-1/1">
                      <h2 class="mobi-ui-font-h2">
                        {{ item.title }}
                      </h2>
                    </div>
                  </div>
                }

                @if (item.subtitle && item.subtext && item.teaser) {
                  <div
                    class="mobi-ui-grid is-centered mobi-calcov-subtab-content mobi-ui-padding-t-xxxl mobi-ui-margin-y-md"
                  >
                    <div class="mobi-ui-col-1/1">
                      <div class="mobi-ui-grid">
                        @if (item.subtitle || item.subtitle) {
                          <div
                            class="mobi-ui-col-1/1 md:mobi-ui-col-4/8 self-stretch flex flex-col justify-center"
                          >
                            @if (item.subtitle) {
                              <h3 class="mobi-ui-text-inked">
                                {{ item.subtitle }}
                              </h3>
                            }
                            @if (item.subtext) {
                              <mobi-text
                                [data]="item.subtext"
                                class="mobi-ui-font-size-200"
                              />
                            }
                          </div>
                        }
                        @if (item.teaser) {
                          <div
                            class="mobi-ui-col-1/1 md:mobi-ui-col-1/2 xl:mobi-ui-col-3/8 xl:mobi-ui-offset-1/8"
                          >
                            <mobi-teaser
                              class="block"
                              [bundle]="item.teaser.bundle"
                              [published]="item.teaser.published"
                              [teaserUrl]="
                                (item.teaser.calculatorCta
                                  | extractUrl
                                  | calcUrl
                                    : (item.teaser.calculatorCtaAuth | extractUrl)) ||
                                (item.teaser.consultationCta | extractUrl)
                              "
                              [teaserTarget]="
                                item.teaser.calculatorCta?.options?.attributes?.target ||
                                item.teaser.consultationCta?.options?.attributes
                                  ?.target ||
                                '_self'
                              "
                              [teaserTitle]="item.teaser.teaserTitle"
                              [teaserText]="item.teaser.teaserText"
                              [teaserImage]="item.teaser.teaserImage"
                              [secondaryActionUrl]="item.teaser.url | extractUrl"
                              [secondaryActionTarget]="
                                item.teaser.url.options?.attributes?.target
                              "
                              [secondaryActionText]="secondaryCtaLabel()"
                              [bundle]="item.teaser.bundle"
                              [trackingId]="item.teaser.uuid"
                              [interceptPrimaryCta]="hasPrerollout(item.teaser)"
                              (primaryCtaClick)="
                                onPromotedTeaserClick($event, item.teaser)
                              "
                            />
                          </div>
                        }
                      </div>
                    </div>
                  </div>
                }
                <mobi-content-section [id]="'calcov-view'" width="lg" [content]="content">
                  <ng-template #content>
                    <h2 class="">{{ item.overviewTitle }}</h2>
                    @if (item.viewId) {
                      <mobi-view
                        [viewId]="item.viewId"
                        [display]="item.viewDisplay || 'default'"
                        [title]="item.overviewTitle || ''"
                        [rowFormatter]="formatRows"
                        [includes]="[
                          'field_cm_tax_product',
                          'field_cm_teaser_image.field_media_image',
                          'field_cm_procov_illu.field_svg_file',
                        ]"
                        [results]="result"
                      >
                        <ng-template #result let-rows="rows">
                          @if (rows() && rows().length) {
                            <mobi-teaser-list
                              [isMobileSlider]="false"
                              [teasers]="rows()"
                              [teaserStyle]="teaserStyle()"
                              [isCalcov]="true"
                              (prerolloutClick)="onTeaserListPrerolloutClick($event)"
                            />
                          }
                        </ng-template>
                      </mobi-view>
                    }
                  </ng-template>
                </mobi-content-section>
              </div>
            }
          </div>
        }
      </ng-template>
    </mobi-split-button-section>
  }
</div>

<mobi-prerollout-overlay
  #prerolloutOverlay
  [nodeId]="prerolloutNodeId()"
  [prerolloutUrl]="prerolloutUrl()"
  [regularUrl]="prerolloutRegularUrl()"
  [ctaTarget]="prerolloutCtaTarget()"
  [trackingContext]="prerolloutTrackingContext()"
  [trackingName]="prerolloutTrackingName()"
/>
